import { TruncatePipe } from '../../pipes';
import { SortableHeaderDirective } from './directive/sortable.directive';
import { TableExpansionDirective } from './directive/table-expansion.directive';
import { TableCellDirective } from './directive/table.cell.directive';
import { PaginationComponent } from './pagination/pagination.component';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { SearchFiltersComponent } from './search-filters/search-filters.component';
import { TableComponent } from './table.component';

export const SIAT_TABLE_MODULE = [
  TableComponent,
  SearchBarComponent,
  SearchFiltersComponent,
  PaginationComponent,
  SortableHeaderDirective,
  TableExpansionDirective,
  TableCellDirective,
  TruncatePipe,
] as const;
